<template>
  <div class="importSpaceBox" id="dialog3">
    <h4 class="title">
      导入空间数据
    </h4>
    <div class="line"></div>

    <el-form ref="form" :model="form" label-width="80px" :rules="rules" style="margin:30px 0 10px;">
        <el-form-item label="空间数据来源:" label-width="120px" style="display:inline-block">
          <el-input v-model="form.fileName" placeholder="请输入来源" readonly></el-input>
        </el-form-item>
        <el-form-item label="" label-width="80px" style="vertical-align: top;display:inline-block;margin-left:-80px;">
          <input type="file" @change="uploads($event)" multiple ref="files" style="display:none"/>
          <!-- <input type="file" multiple ref="files" style="display:none"/> -->
          <button class="addBtn" @click="selectFiles" type="button">上传文件</button>
          <!-- <button class="addBtn" @click="uploads($event)" type="button">点击上传</button> -->
        </el-form-item>
        <!-- <el-form-item label="路径:" label-width="80px" style="display:inline-block">
          <el-input v-model="form.url" placeholder="请输入路径"></el-input>
        </el-form-item> -->
        <el-form-item label="名称:"  prop="name" label-width="80px" style="display:inline-block">
          <el-input v-model="form.name" ></el-input>
        </el-form-item>
        <el-form-item label="说明:" prop="remark" label-width="70px" style="display:inline-block">
          <el-input v-model="form.remark"></el-input>
        </el-form-item>
        <el-form-item label="数据库类别:" prop="types" label-width="120px" style="display:inline-block">
          <el-select v-model="form.query" :disabled="disabled1" >
            <el-option
              v-for="item in types"
              :key="item.value"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="图层类别:" prop="layerTypes" label-width="100px" style="display:inline-block">
          <!-- <el-checkbox-group v-model="checkList" style="padding-top:5px;" @change="checkListChange">
            <el-checkbox label=1 >水系</el-checkbox>
            <el-checkbox label=2>植被</el-checkbox>
            <el-checkbox label=3>道路</el-checkbox>
            <el-checkbox label=4>居民区</el-checkbox>
          </el-checkbox-group> -->
          <el-radio-group v-model="checkList" style="padding-top:8px;" @change="checkListChange">
            <el-radio v-for="item in layerTypes" :label="item.value" :key="item.value">{{item.name}}</el-radio>
          </el-radio-group>
           <!-- <el-checkbox-group v-model="checkList" style="padding-top:5px;" @change="checkListChange">
            <el-checkbox v-for="item in layerTypes" :label="item.value" :key="item.value">{{item.name}}</el-checkbox>
          </el-checkbox-group> -->
        </el-form-item >
         <el-form-item label-width="30px" style="display:inline-block">
        <el-input v-model="form.layerTyped" v-if="showOhter" style="width:200px" placeholder="请输入自定义图层类别"></el-input>
        </el-form-item>
    </el-form>

    <!-- <div style="height:450px;border:1px solid red;" id="map-main"> -->
    <div :style="mapCss" ref="basicMapbox" v-loading="mapLoading">
      <img :style="imgCss" :src="gridUrl" alt="" class="mapImg" v-show="showBaseMap">
    </div>

    <div class="bottomBtnBox">
      <button class="sureBtn" @click="importData('form')">入库</button>
      <button class="backBtn" @click="backToPersonal">返回</button>
    </div>

  </div>
</template>

<script>
import request from '@/utils/request'
import {Loading} from 'element-ui';
// import common from './../../../public/arcgisjs/common.js';
// // 导入esri-loader（地图渲染）
// import esriLoader from "esri-loader";
// import { loadCss } from "esri-loader";
import mapboxgl from "mapbox-gl";//加载MAPBOX
import 'mapbox-gl/dist/mapbox-gl.css'//加载MAPBOX
export default {
  name: 'importSpaceData',
  data(){
    return {
      form:{
        url:'',
        name:'',
        remark:'',
        query: '1',
        layerTyped:'',
        fileName:''
      },
      disabled1:false,
      types:[],
      importId:'',
      layerTypes:[],
      importname:'',
      checkList:[],
      rules :{
        name:[
          { required: true,message: '请输入导入表名', trigger: 'blur' }
        ],
        types:[
          { required: false, message: '请选择数据库类型',ttrigger: 'change'}
        ],
        remark:[
           { required: false,message: '请输入说明信息', ttrigger: 'blur'}
        ],
        layerTypes:[
           { required: false, ttrigger: 'change'}
        ]
      },
      showOhter:false,
      gridUrl: '../../images/baseMap.png',
      showBaseMap: true,
      mapCss:'height:450px;',
      imgCss:'width:100%;height:100%',
      mapLoading: false
    }
  },
  created(){
    this.getlayerType();
      for (let key in this.layerTypes) {
        this.$set(this.checked, key, [])
      }
    this.getDatabaseType();
  },
   mounted(){
    // 加载CSS
    // loadCss('/arcgisjs/arcgis_js_api/4.12/dijit/themes/claro/claro.css');
    // loadCss('/arcgisjs/arcgis_js_api/4.12/esri/css/main.css');
    // common.appConfig = common.getConfig();
    // window.common = common;
    // const esriOptions = {
    //   url: "/arcgisjs/arcgis_js_api/4.12/init.js",
    //   dojoConfig:{
    //     parseOnLoad: true,
    //     async: true,
    //     packages: [{ 
    //       name: '',
    //       location: ""
    //     }] 
    //   }
    // }
    // this.$nextTick(() => {
    //   if (!esriLoader.isLoaded()) {
    //     esriLoader.loadScript(esriOptions);
    //   }
    // })
  },
  methods:{
    /**
     * 文件上传事件
     */
    uploads(e) {
      // 文件上传接口参数
      let uploadData = new FormData();
      // 先清空视图中的文件名列表
      this.form.fileName = '';
      // 用户点击取消，此时文件列表大小为0，不执行任何操作
      if (e.target.files.length < 1) {
        return;
      }
      for (let file of e.target.files) {//多文件上传
        // 文件大小限制在200MB
        var limit200MB = 1024 * 1024 * 200;
        if (file.size >= limit200MB) {
          this.form.fileName = '';
          this.$refs.files.value = null;
          this.$message.error("上传文件不能大于200MB");
          return;
        }
        // 更新视图中的文件名列表
        this.form.fileName += file.name + ',';
        // 文件列表参数
        uploadData.append('files', file);
      }
      // 去掉最后的逗号
      if (this.form.fileName != '') {
        this.form.fileName = this.form.fileName.substring(0, this.form.fileName.length - 1);
      }
      this.$refs.files.value = null;
      // 当前登录用户参数
      uploadData.append("username", JSON.parse(localStorage.getItem('portalUserName')));
      var uploadLoading = Loading.service({
        target:'.importSpaceBox',
        lock:true,
        text: '文件上传中',
        // background: 'rgba(0, 0, 0, 0.7)'
      });
      return new Promise((resolve, reject) => {
        request({headers: {'Content-Type': 'multipart/form-data'},url:'/portal/mydata/spatialdata/uploadSptlDataFiles', method:'post',data: uploadData, timeout: 1000 * 60 * 10})
        .then(response => {
          uploadLoading.close();
          // console.log(response.data);
          if (response.data.code == '201') {
            this.$message({
              message:response.data.msg,
              duration:3000,
              type: 'success'
            });
            this.url=response.data.data;
            var named=this.url.substring(this.url.lastIndexOf(".") + 1)
            if(named=='tif'){
              this.disabled1=true;
            }
          }
          resolve(response.data)
        }).catch(error => {
          uploadLoading.close();
          reject(error)
        })
      })
    },
    selectFiles() {
      this.$refs.files.click();
    },
    //返回个人中心首页
    backToPersonal(){
      this.$emit('backPersonal',true,this.importId)
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
    //多选框改变事件
     checkListChange(val){
       console.log(val);
       if(val==6){
         this.showOhter=true;
       }else{
         this.showOhter=false;
       }
    },
    getDatabaseType() {
       return new Promise((resolve, reject) => {
          request({url:'/portal/mydata/dict/getDatabaseType', method:'post',timeout: 1000 * 60 * 1})
          .then(response => { 
            console.log(response.data);
              let list = response.data.data
               this.types= list
              resolve(list)
          }).catch(error => {
            reject(error)
           
          })
        })
    },
     getlayerType() {
       return new Promise((resolve, reject) => {
          request({url:'/portal/mydata/dict/getLayerType', method:'post',timeout: 1000 * 60 * 1})
          .then(response => { 
            console.log(response.data);
              let list = response.data.data
               this.layerTypes= list
              resolve(list)
          }).catch(error => {
            reject(error)
           
          })
        })
    },
     getimportId(itableName) {
       return new Promise((resolve, reject) => {
          request({url:'/portal/mydata/spatialdata/getImportId?tableName=' + itableName, method:'post',timeout: 1000 * 60 * 1})
          .then(response => { 
            console.log(response.data);
            this.importId=response.data.data;
          }).catch(error => {
            reject(error)
          })
        })
    },
    // 加载地图
    initMap(itableName){
      this.mapLoading = true;
      var params = {
        is_deleted: 0,
        createUser: JSON.parse(localStorage.getItem('portalUserName'))
      };
      return new Promise((resolve, reject) => {
        request({url:'/portal/mydata/spatialdata/find', method:'post' ,data:params, timeout: 1000 * 60 * 1})
        .then(response => {
          // 更新页面我的数据总数
          let resList = response.data.data.records.concat();
          for (let i = 0; i < resList.length; i++) {
            var tblInfo = resList[i];
            if (tblInfo.itableName == itableName) {
              this.$nextTick(() => {
                const url = "/portal/mydata/spatialdata/getGeoJSON?tableName=" + itableName;
            
                var map = new mapboxgl.Map({
                    container:this.$refs.basicMapbox,
                  //center: [116.326984,39.984248],
                  zoom: 5,
                  style: {
                      "version": 8,
                      "sources": {
                          "composite": {
                              //矢量类型
                              "type": "geojson",
                              "data": url,
                              
                          }
                      },
                      "layers": [
                          {
                                "id": "polygonlayer",
                                "type": "fill",
                                "source": "composite",
                                "paint": {
                                    "fill-color": "red",
                                    "fill-opacity": 0.4
                                },
                                "filter": ["==", "$type", "Polygon"]
                            },
                            {
                              'id': 'pointlayer',
                              'type': 'circle',
                              'source': "composite",
                              "filter": ["==", "$type", "Point"],
                              'paint': {
                                  // make circles larger as the user zooms from z12 to z22
                                  'circle-radius': {
                                      'base': 4,
                                      'stops': [[12, 2], [22, 180]]
                                  },
                                  "circle-color": "#B42222"
                              },
                          },
                          {
                              'id': 'linelayer',
                              'type': 'line',
                              'source': "composite",
                              "filter": ["==", "$type", "LineString"],
                              "layout": {
                                  "line-join": "round",
                                  "line-cap": "round"
                              },
                              "paint": {
                                  "line-color": "#BF93E4",
                                  "line-width": 5
                              }
                          }
                      ],
                    
                  }
            });
                map.on('load', ()=> {
                  map.fitBounds([[tblInfo.minX,tblInfo.minY], [tblInfo.maxX,tblInfo.maxY]]);
                  this.mapLoading = false;
                })
              })
              break;
            }
          }
          resolve(response.data)
        }).catch(error => {
          this.mapLoading = false;
          reject(error)
        })
      })

      // 加载的顺序不能混乱，比如"esri/map"在第一，Map就要在第一
      // esriLoader.loadModules([
      //   "esri/Map", 
      //   "esri/layers/GeoJSONLayer",
      //   "esri/views/MapView"
      // ])
      // .then(([
      //   Map, 
      //   GeoJSONLayer,
      //   MapView
      // ]) => {
      //   const url = "/portal/mydata/spatialdata/getGeoJSON?tableName=" + itableName;
      //   const geojsonLayer = new GeoJSONLayer({
      //     url: url,
      //     // copyright: "USGS Earthquakes"
      //   });
      //   const map = new Map({
      //     // basemap: "gray",
      //     layers: [geojsonLayer]
      //   });
      //   const view = new MapView({
      //     container: "map-main",
      //     center: [-168, 46],
      //     zoom: 5,
      //     map: map
      //   });
      //   geojsonLayer.queryExtent(geojsonLayer.createQuery()).then(function(results){
      //     view.goTo(results.extent);  // go to the extent of the results satisfying the query
      //   });
      // })
    },
    importData(formName){
      this.$refs[formName].validate((valid) => {
      if (valid) {
       var saveLoading = Loading.service({
        target:'#dialog3',
        lock:true,
        text: '正在导入',
        // background: 'rgba(0, 0, 0, 0.7)'
      });
      var listd=''
      let list=this.checkList;
      if(list){
        listd=list[0]
        for(var i=1;i<list.length;i++){
        //  var typ=list[i];
          listd=listd+','+list[i];
        }
      }
      // console.log(listd);
      // console.log(this.form.layerTyped);
      if(this.url==null ||this.url==undefined){
        saveLoading.close();
        this.$message({message: "文件未上传或上传失败，请重新上传文件",type: 'error'})
      }else{
        console.log(this.form.query);
      var paramd = {
        databaseType:this.form.query,
        instruction:this.form.remark,
        layerType:listd,
        otherLayertype:this.form.layerTyped,
        shpurl:this.url,
        tablename:this.form.name,
        createUser:JSON.parse(localStorage.getItem('portalUserName'))
      };
      console.log(paramd);
       return new Promise((resolve, reject) => {
          request({url:'/portal/mydata/spatialdata/importSubmit',params:paramd, method:'post',timeout: 1000 * 60 * 30})
         .then(response => { 
           saveLoading.close();
            console.log(response.data);
              let list = response.data
               this.types= list
               if(response.data.code=='200'){
                 console.log(response.data.data);
                 this.importname=response.data.data;
                 var typed=this.url.substring(this.url.lastIndexOf(".") + 1);
                 console.log(typed);
                 typed = typed.toLowerCase();
                if(typed=='shp'||typed=='json'){
                  this.showBaseMap = false;
                  this.mapCss = "height:450px;border:1px solid red;"
                   this.initMap(response.data.data);
                   this.getimportId(response.data.data);
                }
                if (typed == 'tif') {
                  this.generateGridImg(this.url, response.data.data);
                }
                 this.getDatabaseType();
               }
               this.layerType=false;
              resolve(list)
          }).catch(error => {
             saveLoading.close();
            reject(error)
          })
        })
      }
      }
        });
    },
    /**
     * 生成栅格数据预览图
     */
    generateGridImg(gridUrl, tblName) {
      var params = {
        tifFileUrl: gridUrl
      };
      return new Promise((resolve, reject) => {
        request({url:'/portal/mydata/spatialdata/generateTiffPvmImg', method:'post' ,params:params, timeout: 1000 * 60 * 3})
        .then(response => {
          // this.gridUrl = encodeURIComponent(response.data.data);
          this.gridUrl = response.data.data;
          this.mapCss = '';
          this.imgCss = 'border:1px solid red;max-width:100%;';
          // 生成栅格数据缩略图
          var index = response.data.data.lastIndexOf("/");
          if (index < 0) {
            index = response.data.data.lastIndexOf("\\");
          }
          var fileName = response.data.data.substring(index + 1, response.data.data.length);
          fileName = fileName.substring(fileName.indexOf("pvmImg-") + "pvmImg-".length, fileName.length);
          console.log('fileName');
          console.log(fileName);
          this.generateGridThumbnail(gridUrl, tblName, fileName);
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 生成栅格数据缩略图
     */
    generateGridThumbnail(gridUrl, tblName, fileName) {
      var params = {
        tifFileUrl: gridUrl,
        username: JSON.parse(localStorage.getItem('portalUserName')),
        tableName: tblName,
        fileName: fileName
      };
      return new Promise((resolve, reject) => {
        request({url:'/portal/mydata/spatialdata/generateTiffThumbnail', method:'post' ,params:params, timeout: 1000 * 60 * 3})
        .then(response => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
</script>

<style scoped>
.importSpaceBox{width:100%;padding:0;border-radius:5px;text-align:left;}
.importSpaceBox .title{border-left:2px solid #4da1ff;text-indent:10px;color:#4da1ff}
.line{height:1px;margin:15px 0;border-bottom:1px solid #eee;}
.tableTitle{margin:5px 0 15px;color:#4da1ff}
.tableTitle img{vertical-align:middle;width:14px;}
.btnBox{margin:10px 0;}
.bottomBtnBox{margin-top:20px;text-align:right}
</style>
